import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import Cleave from 'cleave.js/react';

export const PercentBeforeSession = (props) => {
  const { formData, handlePercent } = props;

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>3.1</span>
        </div>
      )}
      titleUA="Опитування ДО сесії"
      titleEN="Survey BEFORE the session"
      children={(
        <div className="flex-group">
          <Cleave
            placeholder="0"
            id="percentage_before_session"
            name="percentage_before_session"
            className="number"
            value={formData.info.final_indicators.percentage_before_session}
            autoComplete="off"
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => handlePercent('percentage_before_session', e.target.value.replace(/^0+/, ''))}
            disable="false"
          />
          <span>%</span>
        </div>
      )}
    />
  );
};
